/**
 * Handle fixed logo visibility animations
 */

export function initLogoAnimation() {
    const footer = document.querySelector('footer');
    if (!footer) return;

    /**
     * Generic logo animation handler
     * @param {string} selector - CSS selector for the logo
     * @param {object} options - Animation options
     */
    function setupLogoAnimation(selector, options = {}) {
        const logo = document.querySelector(selector);
        if (!logo) return;

        const {
            type = 'footer', // 'footer' or 'scroll'
            multiplier = 1,  // Window height multiplier
            debug = false    // Enable console logging
        } = options;

        function checkPosition() {
            let shouldHide = false;

            if (type === 'scroll') {
                // Hide based on scroll position
                const scrolled = window.scrollY;
                const windowHeight = window.innerHeight;
                const hidePoint = windowHeight * multiplier;
                
                if (debug) {
                    console.log(`${selector} - scrolled:`, scrolled, 'hidePoint:', hidePoint);
                }
                
                shouldHide = scrolled >= hidePoint;
            } else {
                // Hide based on footer position
                const footerRect = footer.getBoundingClientRect();
                const windowHeight = window.innerHeight * multiplier;
                shouldHide = footerRect.top <= windowHeight;
            }

            // Apply opacity change
            logo.style.transition = 'opacity 0.3s ease';
            logo.style.opacity = shouldHide ? '0' : '1';
        }

        // Attach event listener and run initial check
        window.addEventListener('scroll', checkPosition);
        checkPosition();
    }

    // Configure animations for each logo
    const logoConfigs = [
        {
            selector: '.modulaire__logo',
            options: { type: 'footer', multiplier: 1 }
        },
        {
            selector: '.vision__logo',
            options: { type: 'scroll', multiplier: 0.25 }
        },
        {
            selector: '.blog__logo',
            options: { type: 'footer', multiplier: 0.75 }
        },
        {
            selector: '.offers__logo',
            options: { type: 'footer', multiplier: 0.75 }
        }
    ];

    // Initialize all logo animations
    logoConfigs.forEach(config => {
        setupLogoAnimation(config.selector, config.options);
    });
}